export default ({ request }) => ({
  // Goods
  orderGoodsProofingListApi(data = {}) {
    return request({
      url: '/factory/order/goods/proofing/list',
      method: 'post',
      data,
    })
  },
  orderGoodsProofingDetailApi(data = {}) {
    return request({
      url: '/factory/order/goods/proofing/detail',
      method: 'post',
      data,
    })
  },
  orderGoodsProofingAddSaveApi(data = {}) {
    return request({
      url: '/factory/order/goods/proofing/add/save',
      method: 'post',
      data,
    })
  },
  orderGoodsProofingEditSaveApi(data = {}) {
    return request({
      url: '/factory/order/goods/proofing/edit/save',
      method: 'post',
      data,
    })
  },
  orderGoodsProofingDelApi(data = {}) {
    return request({
      url: '/factory/order/goods/proofing/del',
      method: 'post',
      data,
    })
  },

})
